import { motion, AnimatePresence } from 'motion/react';

interface DotProps {
  color?: string;
  cx?: number;
  cy?: number;
  size: number;
}

export const ActiveDot = ({ cx, cy, size, color }: DotProps) => {
  return (
    <AnimatePresence>
      <g>
        <motion.circle
          cx={cx}
          cy={cy}
          fill={color}
          opacity={0.3}
          r={size * 2}
          style={{ transformOrigin: `${cx}px ${cy}px` }}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
        />
        <motion.circle
          cx={cx}
          cy={cy}
          fill={color}
          r={size}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
        />
      </g>
    </AnimatePresence>
  );
};
